import { __decorate } from "tslib";
import ButtonLoading from '@/components/ButtonLoading.vue';
import ConfirmableButton from '@/components/ConfirmableButton.vue';
import CustomerCard from '@/components/CustomerCard.vue';
import CustomerField from '@/components/CustomerField.vue';
import DatePicker from '@/components/DatePicker.vue';
import DurationField from '@/components/DurationField.vue';
import Hours from '@/components/Hours.vue';
import Modal from '@/components/Modal.vue';
import Money from '@/components/Money.vue';
import ServicesSelect from '@/components/ServicesSelect.vue';
import TeamSelect from '@/components/TeamSelect.vue';
import AppointmentNotification from '@/components/TimeTemplates/AppointmentNotification.vue';
import ModalMixin from "@/mixins/modal-mixin";
import WorkPlaceSelect from '@/Pages/Company/WorkPlaces/WorkPlaceSelect.vue';
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapActions, mapGetters, mapState } from 'vuex';
let FastModalComponent = class FastModalComponent extends Mixins(ModalMixin) {
    id;
    getCustomer;
    getUser;
    findAppointments;
    findWorkplaces;
    fetchAppointmentsFromBack;
    fetchCustomer;
    createCustomer;
    createAppointment;
    patchAppointment;
    user;
    newCustomer = {
        name: '',
        phone: '',
        birth_date: '',
        gender: 'female'
    };
    customerId = null;
    appointments = [];
    errors = {};
    data = {};
    saveButtonLoading = false;
    params = {
        query: {
            $limit: 20,
        }
    };
    get calendarOptions() {
        return {
            disableMobile: true,
        };
    }
    get isSaveDisabled() {
        if (!this.appointments.length)
            return true;
        return this.appointments.some(appointment => {
            return appointment.services.some(el => {
                if (this.$settings.appointmentServiceRequired)
                    return !el.treatment;
                return !el.duration;
            });
        });
    }
    get customer() {
        if (!this.customerId)
            return;
        return this.getCustomer(this.customerId);
    }
    get servicesPlaceholder() {
        if (this.$settings.appointmentServiceRequired)
            return this.$t('Select service') + "*";
        return this.$t('Select service');
    }
    get workplaces() {
        return this.findWorkplaces().data;
    }
    get onlyFutureTimeTemplate() {
        if (!this.data.timeTemplate)
            return;
        const checkAppointmentNotificationTimePast = (appointment, delta) => {
            return this.$moment(appointment.startAt).subtract(delta, 'seconds').isBefore();
        };
        const template = this.data.timeTemplate;
        if (template.deltas) {
            template.deltas = template.deltas.filter((delta) => !this.appointments.every(appointment => checkAppointmentNotificationTimePast(appointment, delta.delta)));
        }
        return template;
    }
    isDurationFieldDisabled(service) {
        return this.$settings.appointmentServiceRequired && !service.treatment;
    }
    durationFieldState(item) {
        if (!item.treatment)
            return null;
        if (!item.duration)
            return false;
    }
    ;
    hoursFieldState(item, hour) {
        if (!item.treatment)
            return null;
        if (item.duration && !hour)
            return false;
    }
    clearCustomer() {
        this.customerId = null;
    }
    findItems() {
        this.fetchAppointmentsFromBack(this.params);
    }
    openDatePicker(position, index) {
        // @ts-ignore
        const flatPickrInstance = this.$refs['datePickerWrap_' + index][0].$refs.datePickerWrap.fp;
        flatPickrInstance._positionElement = window.document.getElementById(position + '_' + index); // eslint-disable-line
        flatPickrInstance.open();
    }
    findSlots(appointmentIDX, service, workPlace) {
        let appointment = this.appointments[appointmentIDX];
        if (!service.userId)
            return [];
        let queryParams = {
            query: {
                status: { $nin: ['completed', 'cancelled'] },
                startAt: {
                    $gt: this.$moment(appointment.appointmentAt).startOf('day'),
                    $lt: this.$moment(appointment.appointmentAt).endOf('day'),
                }
            }
        };
        if (workPlace)
            // @ts-ignore
            queryParams.query['services.workPlaceId'] = { $ne: null };
        else
            // @ts-ignore
            queryParams.query['services.userId'] = service.userId;
        // @ts-ignore
        const result = this.findAppointments(queryParams).data;
        return result.flatMap(appointment => appointment.services.map(serviceItem => {
            return {
                start: serviceItem.startAt,
                end: this.$moment(serviceItem.startAt).add(service.duration, 'minute').format(),
                workPlaceId: serviceItem.workPlaceId
            };
        }));
    }
    ;
    fetchAppointments(appointmentIDX, service) {
        let appointment = this.appointments[appointmentIDX];
        if (!service)
            return false;
        if (!service.userId)
            return false;
        let queryParams = {
            query: {
                'services.userId': service.userId,
                startAt: {
                    $gt: this.$moment(appointment.appointmentAt).startOf('day'),
                    $lt: this.$moment(appointment.appointmentAt).endOf('day'),
                }
            }
        };
        // @ts-ignore
        this.fetchAppointmentsFromBack(queryParams);
    }
    workingHours(service) {
        if (!service.userId)
            return;
        return this.getUser(service.userId).schedule;
    }
    ;
    providersParams(appointmentIDX, service) {
        const appointment = this.appointments[appointmentIDX];
        const dayOfweeks = {
            1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday'
        };
        const dayOfWeek = dayOfweeks[this.$moment(appointment.startAt).isoWeekday()];
        const queryParams = {
            // @ts-ignore
            'schedule.dayOfWeek': dayOfWeek,
            public: true,
        };
        if (service.treatment)
            queryParams.treatments = { $in: [service.treatment._id] };
        return {
            query: queryParams
        };
    }
    servicesParams(service) {
        if (!service.userId)
            return;
        let treatmentIds = this.getUser(service.userId).treatments;
        return { query: { _id: { $in: treatmentIds } } };
    }
    ;
    getStartTimeForAppointment(appointment) {
        const startTime = this.$moment(appointment.startAt);
        const startDate = this.$moment(appointment.appointmentAt);
        startTime.set('year', startDate.year());
        startTime.set('month', startDate.month());
        startTime.set('date', startDate.date());
        return startTime.format();
    }
    calculateEndDate(appointmentIDX, service, index) {
        let appointment = this.appointments[appointmentIDX];
        if (!appointment)
            return;
        let duration = 0;
        if (service) {
            this.setServiceDuration(service);
        }
        let services = appointment.services;
        if (this.$settings.appointmentServiceRequired)
            services = appointment.services.filter(service => service.treatment);
        services.forEach((item, idx) => {
            duration += item.duration;
            if (item.treatment)
                duration += ((item.treatment.bufferDuration) ? item.treatment.bufferDuration : 0);
            if (idx === 0) {
                appointment.startAt = item.startAt;
            }
            if (idx + 1 === appointment.services.length) {
                appointment.duration = duration;
                appointment.endAt = this.$moment(appointment.startAt).add(duration, 'minute').format();
            }
            if (idx !== 0 && idx > (index || 0)) {
                const previous = appointment.services[idx - 1];
                const totalDur = previous.duration + ((previous.treatment && previous.treatment.bufferDuration) ? previous.treatment.bufferDuration : 0);
                item.startAt = this.$moment(previous.startAt).add(totalDur, 'minute').format();
                appointment.services.splice(idx, 1, item);
            }
        });
    }
    setServiceDuration(service) {
        if (service.treatment) {
            this.$set(service, 'duration', service.treatment.duration);
        }
    }
    hasBuffer(service) {
        if (!service.treatment)
            return false;
        if (!service.treatment.bufferDuration)
            return false;
        return service.treatment.bufferDuration > 0;
    }
    addService(appointmentIDX) {
        let appointment = this.appointments[appointmentIDX];
        let initial = { quantity: 1, startAt: appointment.endAt };
        const length = appointment.services.length;
        if (length >= 1) {
            initial.userId = appointment.services[length - 1].userId;
        }
        // @ts-ignore
        appointment.services.push(initial);
    }
    removeService(appointmentIDX, index) {
        this.appointments[appointmentIDX].services.splice(index, 1);
        this.calculateEndDate(appointmentIDX, null, index);
    }
    hidden() {
        this.data = {};
        this.errors = {};
        this.newCustomer = {
            name: '',
            phone: '',
            birth_date: '',
            gender: 'female'
        };
        this.appointments = [];
        this.clearCustomer();
    }
    shown() {
        this.$root.$emit('bv::hide::tooltip');
        const { Appointment } = this.$FeathersVuex;
        let data = Appointment.getFromStore('temp');
        let model = {};
        if (data) {
            delete data._id;
            model = this.$deepCopy(data.model);
            new Appointment({
                _id: 'temp'
            });
        }
        if (!model.services)
            model.services = [];
        if (model.startAt)
            model.appointmentAt = this.$moment(model.startAt).local().format('YYYY-MM-DD');
        if (!model.services || !model.services.length) {
            let initial = {
                quantity: 1,
                startAt: this.$moment(model.startAt).format(),
                userId: model.userId || (this.user || {})._id,
            };
            // @ts-ignore
            model.services.push(initial);
        }
        if (!model._id) {
            model.notify = false;
            model.inWaitingList = model.inWaitingList || false;
            model.services[0].quantity = 1;
        }
        if (!model.services[0].userId)
            model.services[0].userId = model.userId || (this.user || {})._id;
        if (model.customerId) {
            this.fetchCustomer(model.customerId);
            this.customerId = model.customerId;
        }
        if (!this.$settings.appointmentServiceRequired && !model.services[0].duration) {
            if (!model.endAt) {
                model.endAt = this.$moment(model.startAt).add(60, 'minute').format();
                model.services[0].duration = 60;
                model.duration = 60;
            }
            else {
                const now = this.$moment(model.endAt);
                const end = this.$moment(model.startAt);
                const duration = Math.trunc(this.$moment.duration(now.diff(end)).asMinutes());
                model.services[0].duration = duration;
                model.duration = duration;
            }
        }
        const modelCopy = this.$deepCopy(model);
        this.data = modelCopy;
        // @ts-ignore
        this.appointments.push(modelCopy);
        if (!this.data.status)
            this.$set(this.data, 'status', '');
        let customerField = document.getElementById('customerFieldInput');
        if (customerField)
            customerField.focus();
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    save() {
        if (!this.customerId) {
            if (!this.newCustomer.name) {
                this.errors = {
                    'customerId': this.$t("customer-field.required").toString()
                };
                return;
            }
            if (!this.newCustomer.phone) {
                this.errors = {
                    'phone': this.$t("phone-field.required").toString()
                };
            }
            let name = this.newCustomer.name.split(' ');
            let [first_name, last_name, middle_name] = name;
            let customerData = {
                ...this.newCustomer,
                first_name,
                last_name,
                middle_name
            };
            // @ts-ignore
            this.createCustomer(customerData).then(result => {
                this.customerId = result._id;
                this.save();
            });
            return;
        }
        if (this.customer && this.customer.stats && this.customer.stats.confirmed && this.customer.stats.confirmed > 0) {
            this.$set(this.data, 'status', 'notConfirmed');
        }
        else {
            this.$set(this.data, 'status', 'new');
        }
        this.saveButtonLoading = true;
        let promises = this.appointments.map((appointment) => {
            this.errors = {};
            let services = appointment.services;
            if (this.$settings.appointmentServiceRequired)
                services = appointment.services.filter(service => service.treatment);
            let data = {
                ...appointment,
                services: services.map(service => {
                    return {
                        treatmentId: service.treatment ? service.treatment._id : null,
                        userId: service.userId,
                        startAt: service.startAt,
                        quantity: service.quantity ? service.quantity : 1,
                        duration: service.duration,
                        workPlaceId: service.workPlaceId
                    };
                })
            };
            return this.saveOne(data);
        });
        Promise.all(promises).then(() => {
            this.close();
            this.$toasted.global.success({
                message: this.$t('Appointments saved')
            });
        }).finally(() => {
            this.saveButtonLoading = false;
        });
    }
    saveOne(data) {
        const appointment = {
            ...data,
            repeat: this.data.repeat,
            customerId: this.customerId,
            timeTemplate: this.onlyFutureTimeTemplate,
            notify: !!this.data.timeTemplate,
            notes: this.data.notes,
            status: this.data.status,
            inWaitingList: this.data.inWaitingList
        };
        if (appointment._id)
            return this.patchAppointment([appointment._id, appointment, {}]);
        return this.createAppointment(appointment);
    }
    addAppointment(appointmentIDX) {
        let appointment = this.$copy(this.appointments[appointmentIDX]);
        appointment.appointmentAt = this.$moment(appointment.appointmentAt).add(1, 'day').format('YYYY-MM-DD');
        appointment.startAt = this.$moment(appointment.startAt).add(1, 'day').format();
        appointment.endAt = this.$moment(appointment.endAt).add(1, 'day').format();
        appointment.services.forEach(element => {
            element.startAt = this.$moment(element.startAt).add(1, 'day').format();
            // @ts-ignore
            element.endAt = this.$moment(element.endAt).add(1, 'day').format();
        });
        this.appointments.splice(appointmentIDX + 1, 0, appointment);
    }
    deleteAppointment(appointmentIDX) {
        this.appointments.splice(appointmentIDX, 1);
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
};
__decorate([
    Prop({ type: String, required: true })
], FastModalComponent.prototype, "id", void 0);
FastModalComponent = __decorate([
    Component({
        name: 'appointment-modal',
        components: {
            CustomerCard,
            WorkPlaceSelect,
            AppointmentNotification,
            Money,
            Modal,
            Hours,
            DatePicker,
            TeamSelect,
            CustomerField,
            DurationField,
            ServicesSelect,
            ConfirmableButton,
            ButtonLoading,
        },
        computed: {
            ...mapState('auth', ['user']),
            ...mapGetters('my-team', { getUser: 'get' }),
            ...mapGetters('appointment', { findAppointments: 'find' }),
            ...mapGetters('work-place', { findWorkplaces: 'find' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
        },
        methods: {
            ...mapActions('appointment', { fetchAppointmentsFromBack: 'find', createAppointment: 'create', patchAppointment: 'patch' }),
            ...mapActions('customers', { fetchCustomer: 'get', find: 'find', createCustomer: 'create' }),
        }
    })
], FastModalComponent);
export default FastModalComponent;
